import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { redirectLegacyHashRoutes } from "./lib/auth-callback";

// The app routes by real browser paths. Rewrite legacy hash-router URLs
// (`/#/projects/...`, `/?error=…#/auth/error`) from bookmarks, stale emails,
// and old server redirects onto their path equivalents BEFORE React mounts.
// Implicit auth payloads (`#access_token=…`) are NOT hash routes and pass
// through untouched — the callback pages consume them (see lib/auth-callback).
redirectLegacyHashRoutes();

createRoot(document.getElementById("root")!).render(<App />);
